import { MilestoneProgressStatus } from './../../../shared/enums/milestone-progress-status';
import { ModalComponent } from './../../../shared/components/modal/modal.component';
import { SendProposalComponent } from './../send-proposal/send-proposal/send-proposal.component';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ComponentFactoryResolver,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { JobPreview } from '../../../dashboards/models/job-preview';
import { AuthenticationResult } from '../../../shared/models/authentication-result';
import { ActivatedRoute, Router } from '@angular/router';
import { JobsStore } from '../../store/jobs-store.service';
import { Subscription } from 'rxjs';
import { Navigation } from '../../../shared/models/navigation';
import { AccountTypes } from '../../../shared/models/AccountTypes';
import { JobSummary } from '../../models/job-summary';
import { JobFilter } from '../../models/job-filter';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/tasks-wizard/services/data-service.service';
import { MilestonePayoutStatus } from 'src/app/shared/enums/milestone-payout-status';
import { AppStore } from '../../../shared/store/lookup-store.service';
import { IReviewResponseDto } from 'src/app/shared/models/responses/review.response';
import { IReviewRequestDto } from 'src/app/shared/models/requests/review.request';
import { EntityTypes } from 'src/app/shared/enums/entity-types';
import { MyJobStatuses } from '../../models/job-statuses';
import { ModalConfig } from '../../../shared/models/modal.config';
import { AppModalComponent } from '../../../shared/components/app-modal/app-modal.component';
import { ModalConfigHelper } from '../../../shared/helpers/modal-config-helper';

@Component({
  selector: 'app-view-job',
  templateUrl: './view-job.component.html',
  styleUrls: ['./view-job.component.scss'],
})
export class ViewJobComponent implements OnInit, OnDestroy {
  @Input() showJobPreviewOnly: boolean;
  @Input() showJobFilters: boolean = true;
  @Input() showDiscussControls: boolean = false;
  @Output() discussClicked = new EventEmitter();
  @ViewChild("confirmationModal") private confirmationModalComponent: AppModalComponent;

  milestoneStatus: string;
  confirmationModalConfig: ModalConfig;
  user: AuthenticationResult = null;
  navigations: Navigation[] = [];
  showApplyControls: boolean = true;
  jobPreview: JobPreview = new JobPreview();
  subscriptions: Subscription[] = [];
  jobsFilter: JobFilter;
  navigatedFromFilterJobs: boolean;
  navigatedFromManageJobs: boolean;
  shouldShowReviewAndMilestone: boolean = false;
  similarJobs: JobSummary[];
  currentJobId: string;
  milestoneProgressStatuses = MilestoneProgressStatus;
  jobReviews: IReviewResponseDto[] = [];
  isReviewGiven = true;
  showDeclineControls: boolean = false;
  entityTypeEnum = EntityTypes;

  constructor(
    private lookupStore: AppStore,
    private uiStore: UiStateStore,
    private jobStore: JobsStore,
    private router: Router,
    private route: ActivatedRoute,
    public resolver: ComponentFactoryResolver,
    public modalService: NgbModal,
    private dataService: DataService
  ) {

    this.confirmationModalConfig = ModalConfigHelper.getConfimationModalDialog(this.onConfirmDismiss, this.onConfirmClose);
    this.lookupStore.loadInitialData();
    this.currentJobId = this.route.snapshot.paramMap.get('jobId');
    this.uiStore.setSelectedJobId(this.currentJobId);

    let navigatedFrom = this.route.snapshot.paramMap.get('navigatedfrom');
    switch (navigatedFrom) {
      case 'search-jobs': {
        this.navigatedFromFilterJobs = true;
        this.navigatedFromManageJobs = false;
        break;
      }
      case 'manage-jobs': {
        this.navigatedFromManageJobs = true;
        this.navigatedFromFilterJobs = false;
        break;
      }
      default: {
        this.navigatedFromFilterJobs = false;
        this.navigatedFromManageJobs = false;
        break;
      }
    }

    let userSubscription = this.uiStore.authenticatedUser.subscribe((user) => {
      if (!user) {
        this.shouldShowReviewAndMilestone = false;
        return;
      }

      this.user = user;
      this.navigations =
        this.user.accountType == AccountTypes.Candidate
          ? Navigation.getCandidateNavigations()
          : Navigation.getEmployerNavigations();
      this.showApplyControls = user.accountType == 0;
      this.showApplyControls =
        this.showApplyControls && !this.showJobPreviewOnly;
    });

    this.subscriptions.push(userSubscription);
  }

  ngOnInit() {

    this.jobStore.getMyJobIds(MyJobStatuses.InProgress).then(inProgressJobs => {
      let myJobs = inProgressJobs;
      this.jobStore.getMyJobIds(MyJobStatuses.Finished).then(finishedJobs => {
        let allJobs = myJobs.concat(finishedJobs);
        if (allJobs.find(jId => jId == this.currentJobId)) {
          this.shouldShowReviewAndMilestone = true;
          this.getJobReviews();
        }
      });
    });

    this.jobStore.getMyJobIds(MyJobStatuses.Invite).then(invitedJobs => {
      if (invitedJobs.find(jId => jId == this.currentJobId)) {
        this.showDeclineControls = true;
      } else {
        this.jobStore.getMyJobIds(MyJobStatuses.Applied).then(appliedJobs => {
          if (appliedJobs.find(jId => jId == this.currentJobId)) {
            this.showDeclineControls = true;
          }
        });
      }
    });

    let selectedJobIdSubscription = this.uiStore.selectedJobId.subscribe(
      (jobId) => {
        if (!jobId) {
          return;
        }

        this.jobStore.getJobPreview(jobId);
      }
    );

    this.subscriptions.push(selectedJobIdSubscription);

    let jobPreviewSubscription = this.jobStore.jobPreview.subscribe((jobPreview) => {
      if (!jobPreview) {
        return;
      }

      this.FilterMileStonesForUser(jobPreview);
      this.jobPreview = jobPreview;
    });

    this.subscriptions.push(jobPreviewSubscription);

    let jobSearchFilterSubscription = this.jobStore.jobSearchFilter.subscribe(
      (filter) => {
        if (!filter) {
          return;
        }

        if (!filter.keyword) {
          return;
        }

        this.jobsFilter = filter;
      }
    );

    this.subscriptions.push(jobSearchFilterSubscription);

    let resultSubscription = this.jobStore.jobSearchResults.subscribe(
      (searchResult) => {
        if (!searchResult) {
          return;
        }

        this.similarJobs = [];
        searchResult.result.forEach((j) => {
          this.similarJobs.push(j);
        });
      }
    );

    this.subscriptions.push(resultSubscription);
  }

  private FilterMileStonesForUser(job: JobPreview) {
    job.jobMilestones = job.jobMilestones?.filter(jm => jm.candidateId == this.user?.accountId);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.uiStore.setSelectedJobId(null);
  }

  onConfirmDismiss = (): boolean => {
    return false;
  };

  onConfirmClose = (): boolean => {
    return true;
  };

  onApplyForJobClicked(): void {
    this.router.navigate(['/apply-job', this.jobPreview.id]);
  }

  onSendProposal(): void {
    if (!this.user) {
      this.router.navigate(['/signin'], {
        queryParams: { returnUrl: this.router.url },
      });
      return;
    }
    const ComponentFactory = this.resolver.resolveComponentFactory(
      SendProposalComponent
    );
    const modalRef = this.modalService.open(ModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.setContent(ComponentFactory);
    this.uiStore.setSelectedJobId(this.jobPreview.id);
  }

  onFavouriteClicked(): void {
    this.jobPreview.bookmarked = !this.jobPreview.bookmarked;
    if (this.jobPreview.bookmarked) {
      this.jobStore.bookmarkJobInLocalStore(this.jobPreview.id);
    } else {
      this.jobStore.unBookmarkJobInLocalStore(this.jobPreview.id);
    }
  }

  isProgressPending = (statusId: number) => {
    return statusId === MilestoneProgressStatus.pending;
  }

  isPaymentCleared = (payoutStatus: number) => {
    return MilestonePayoutStatus.cleared === payoutStatus;
  }

  isInProgress = (statusId: number) => {
    return statusId === MilestoneProgressStatus.inProgress;
  }

  handleMilestoneStatusChangeEvent = (milestoneId: string, progressStatusId: MilestoneProgressStatus) => {
    this.milestoneStatus = MilestoneProgressStatus[progressStatusId];
    this.confirmationModalComponent.open().then(r => {
      if (!r)
        return;
      this.dataService.updateMilestoneStatus(milestoneId, progressStatusId).subscribe(resp => {
        if (resp) {
          this.jobPreview.jobMilestones = resp;
          this.FilterMileStonesForUser(this.jobPreview);
          this.uiStore.setSuccess("Milestone status updated successfully!");
        } else {
          this.uiStore.setSuccess("Unable to update milestone status!");
        }
      });
    });
  }

  refreshMilestones = () => {
    this.dataService.getJobMilestones(this.currentJobId, this.user.accountId).subscribe(resp => {
      this.jobPreview.jobMilestones = resp;
      this.FilterMileStonesForUser(this.jobPreview);
    });
  }

  getJobReviews = () => {
    this.dataService.getJobReview(this.currentJobId).subscribe(resp => {
      this.isReviewGiven = resp.findIndex(x => x.reviewedBy == this.user.accountId) > -1;
      this.jobReviews = resp;
    });
  }

  onReviewSave = (request: IReviewRequestDto) => {
    request.reviewedTo = this.jobPreview.jobPoster;
    request.jobId = this.jobPreview.id;
    request.isClientReview = false;

    this.dataService.submitReview(request).subscribe(resp => {
      this.getJobReviews();
      this.uiStore.setSuccess("Review submitted successfully.");
    });
  };

  onDiscussClicked = () => {
    this.discussClicked.emit();
  }

  onDeclineClicked = () => {
    this.jobStore.declineJobInvite(this.currentJobId, this.user.accountId).then(x => {
      this.uiStore.setSuccess("You have successfully declined this job invite");
    });
  }

}

export class ViewJobPost {
  public title: string;
  public description: string;
  public datePosted: Date;
  public companyLogo: string;
  public offeredSalary: string;
  public sector: string;
  public experience: string;
  public education: string;
  public remainingDays: number;
  public jobType: string;
  public applicants: number;
  public viewsCount: number;
  public requirements: string;
}
